import React from 'react';
import mockUser from './mock-user';

const MockedAuthProvider = (props) => {
  const { AuthContext } = props;

  return (
    <AuthContext.Provider
      value={{
        user: mockUser,
        error: null,
        loginOkta: () => {},
        logout: () => {},
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export { MockedAuthProvider };
